/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Rafinita
 */
export class Rafinita {
    /**
     *
     * @type {string}
     * @memberof Rafinita
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Rafinita
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Rafinita
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Rafinita
     */
    merchantKey: string;
    /**
     *
     * @type {string}
     * @memberof Rafinita
     */
    secretKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Rafinita
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Rafinita
     */
    autoApprove: boolean;
}
